export type PrepDockVisibilityInput = {
  hasLinkedEvent: boolean;
  chatOpen: boolean;
  dismissed: boolean;
  hasPrepContent: boolean;
  isPrepPending: boolean;
  summaryCompleted: boolean;
  isEventNotEnded: boolean;
  isMeetingRecording: boolean;
  explicitlyOpen: boolean;
};

export const MEETING_PREP_READY_SEARCH = {
  tab: 'notes',
  openPrep: true,
} as const;

export function isMeetingOver({
  summaryCompleted,
  isEventNotEnded,
  isMeetingRecording,
}: Pick<
  PrepDockVisibilityInput,
  'summaryCompleted' | 'isEventNotEnded' | 'isMeetingRecording'
>): boolean {
  return summaryCompleted || (!isEventNotEnded && !isMeetingRecording);
}

export function shouldShowPrepDockCard(
  input: PrepDockVisibilityInput
): boolean {
  if (!input.hasLinkedEvent) return false;
  if (input.explicitlyOpen) return true;
  if (input.chatOpen) return false;
  if (isMeetingOver(input)) return false;
  if (input.hasPrepContent || input.isPrepPending) return true;
  return !input.dismissed;
}
